import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { RiMenu2Fill } from "react-icons/ri";
import logo from "../Images/jaiclub2.png";
import logo2 from "../Images/jaiclub.png";
import logo3 from "../Images/logo-4.png";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { setNavlinksState } from "../Redux/showNavlinksSlice.js";
import BackButton from "./Backbutton.jsx";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [click, setClick] = useState(false);
  const dispatch = useDispatch();
  const showNavlinks = useSelector((state) => state.showNavlinks.value);
  const [show, setShow] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // State for tracking which dropdown is open
  const [dropdownOpen, setDropdownOpen] = useState({
    about: false,
    info: false
  });

  // Toggle dropdown function to ensure only one dropdown is open at a time
  const toggleDropdown = (dropdownName, isOpen) => {
    setDropdownOpen(prev => ({
      about: dropdownName === "about" ? isOpen : false,
      info: dropdownName === "info" ? isOpen : false
    }));
  };

  const handleClick = () => {
    setClick(!click);
    setShow(false);
    dispatch(setNavlinksState(false));
  };

  useEffect(() => {
    if (location.pathname === "/") {
      setShow(false);
      dispatch(setNavlinksState(true));
    } else {
      setShow(false);
      dispatch(setNavlinksState(false));
    }
  }, [location.pathname, dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinkClass = ({ isActive }) =>
    isActive ? "nav-links active" : "nav-links";

  return (
    <div>
      {showNavlinks ? (
        <>
          {/* Mobile Navbar */}
          <div
            className={`d-block d-lg-none w-100 ${scrolling ? "scrolled" : ""}`}
            style={{ position: "fixed", top: "1vh", zIndex: "999" }}
          >
            <div
              className={`w-100 d-flex justify-content-between align-items-baseline ${scrolling ? "scrolled" : ""}`}
            >
              <div className="d-flex justify-content-between align-items-center bg-dark rounded-5">
                <BackButton />
                <span
                  className="me-4 d-block "
                  onClick={handleShow}
                  style={{
                    cursor: "pointer",
                    color: "#E82561",
                    borderRadius: "50px",
                    padding: "5px",
                  }}
                >
                  <RiMenu2Fill style={{ fontSize: 25 }} />
                </span>
              </div>

              <div
                className="navbar-brand"
                onClick={() => navigate("/")}
                style={{
                  color: "#E2DFD0",
                  fontFamily: "Poppins",
                  cursor: "pointer",
                  borderRadius: "50px",
                  padding: "5px",
                }}
              >
                <img
                  src={logo3}
                  loading="lazy"
                  alt="images"
                  style={{ width: "50%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>

          {/* Desktop Navbar - Only shown on homepage */}
          {location.pathname === "/" && (
            <nav
              className={`navbar navbar-expand-lg z-50 fixed-top d-lg-block d-none ${scrolling ? "scrolled" : "scrolled"}`}
              style={{ backgroundColor: "#fff", zIndex: 1050, height: "95px" }}
            >
              <div className="container-fluid p-0">
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <div
                    className="navbar-brand"
                    onClick={() => navigate("/")}
                    style={{
                      color: "#E2DFD0",
                      fontFamily: "Poppins",
                      cursor: "pointer",
                      border: "1px solid black",
                      borderRadius: "50px",
                      padding: "5px",
                      paddingLeft:"20px"
                    }}
                  >
                    <img
                      src={logo}
                      style={{ width: "70%", objectFit: "contain" }}
                      alt="logo"
                    />
                  </div>
                  <ul className="navbar-nav mx-auto gap-0 mb-2 mb-lg-0">
                    <li className="nav-item ms-4">
                      <NavLink className={navLinkClass} >
                        Home 
                      </NavLink>
                    </li>

                    {/* About Dropdown */}
                    <li className="nav-item ms-4">
                      <Dropdown
                        className="border-0"
                        show={dropdownOpen.about}
                        onToggle={(isOpen) => toggleDropdown("about", isOpen)}
                      >
                        <Dropdown.Toggle
                          variant="NavLink"
                          className="nav-links text-white"
                          id="dropdown-basic"
                        >
                          About
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className="dropdown-menu bg-white"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            zIndex: 2000,
                          }}
                        >
                          <Dropdown.Item as={NavLink} to="/History" className={navLinkClass} onClick={handleClick}>
                            History
                          </Dropdown.Item>
                          <Dropdown.Item as={NavLink} to="/Management" className={navLinkClass} onClick={handleClick}>
                            Management
                          </Dropdown.Item>
                          <Dropdown.Item as={NavLink} to="/Affiliation" className={navLinkClass} onClick={handleClick}>
                            Affiliations
                          </Dropdown.Item>
                          <Dropdown.Item as={NavLink} to="/Event" className={navLinkClass} onClick={handleClick}>
                            Events
                          </Dropdown.Item>
                          <Dropdown.Item as={NavLink} to="/Gallery" className={navLinkClass} onClick={handleClick}>
                            Gallery
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>

                    <li className="nav-item ms-4">
                      <NavLink to="/Facility" className={navLinkClass} onClick={handleClick}>
                        Club Facility
                      </NavLink>
                    </li>
                    <li className="nav-item ms-4">
                      <NavLink to="/Membership" className={navLinkClass} onClick={handleClick}>
                        Membership
                      </NavLink>
                    </li>

                    {/* Information Dropdown */}
                    <li className="nav-item ms-4">
                      <Dropdown
                        className="border-0"
                        show={dropdownOpen.info}
                        onToggle={(isOpen) => toggleDropdown("info", isOpen)}
                      >
                        <Dropdown.Toggle
                          variant="NavLink"
                          className="nav-links text-white"
                          id="dropdown-basic-info"
                        >
                          Informations
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className="dropdown-menu"
                          style={{
                            backgroundColor: "#ffffff",
                            border: "1px solid #ccc",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          <Dropdown.Item as={NavLink} to="/Notices" className={navLinkClass} onClick={handleClick}>
                            Notices
                          </Dropdown.Item>
                          {/* <Dropdown.Item as={NavLink} to="/jaiclublive" className={navLinkClass} onClick={handleClick}>
                            Jaiclub Connect
                          </Dropdown.Item> */}
                          <Dropdown.Item as={NavLink} to="/message" className={navLinkClass} onClick={handleClick}>
                            Messages
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      
                    </li>

                    <li className="nav-item ms-4">
                      <NavLink to="/Contact" className={navLinkClass} onClick={handleClick}>
                        Contact
                      </NavLink>
                    </li>
                  </ul>

                  <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                    <li className="nav-item ms-4" style={{fontSize:"24px"}}>
                      <NavLink to="/Login" className={navLinkClass} onClick={handleClick}>
                        Login
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          )}

          {/* Offcanvas Menu */}
          <Offcanvas show={show} onHide={handleClose} style={{ backgroundColor: "black" }} placement="start">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="text-dark">
                <div className="d-flex align-items-end">
                  <img src={logo} loading="lazy" alt="images" style={{ width: 80, objectFit: "cover" }} />
                  <div className="ps-3">
                    <div style={{ fontSize: "2em", fontWeight: 600, color: "#DC143C", fontFamily: '"Playwrite FR Moderne", cursive' }}>
                      Jai Club
                    </div>
                    <div style={{ fontSize: ".7em", fontWeight: 600, color: "#fff" }}>
                      THE TRUE SPIRIT OF LIFE
                    </div>
                  </div>
                </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ul className="navbar-nav flex-column">
                <li className="nav-item ms-4">
                  <NavLink to="/" className={navLinkClass} onClick={handleClick}>
                    Home
                  </NavLink>
                </li>

                {/* About Dropdown (Mobile) */}
                <li className="nav-item ms-4">
                  <div
                    className="text-white border-0 text-left d-flex justify-content-between align-items-center ms-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleDropdown("about", !dropdownOpen.about)}
                  >
                    About
                  </div>
                  {dropdownOpen.about && (
                    <ul className="flex-column ms-3 mt-2 list-unstyled">
                      <li>
                        <NavLink to="/History" className={navLinkClass} onClick={handleClick}>
                          History
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Management" className={navLinkClass} onClick={handleClick}>
                          Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Affiliation" className={navLinkClass} onClick={handleClick}>
                          Affiliations
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Event" className={navLinkClass} onClick={handleClick}>
                          Events
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Gallery" className={navLinkClass} onClick={handleClick}>
                          Gallery
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="nav-item ms-4">
                  <NavLink to="/Facility" className={navLinkClass} onClick={handleClick}>
                    Club Facility
                  </NavLink>
                </li>

                <li className="nav-item ms-4">
                  <NavLink to="/Membership" className={navLinkClass} onClick={handleClick}>
                    Membership
                  </NavLink>
                </li>

                {/* Informations Dropdown (Mobile) */}
                <li className="nav-item ms-4">
                  <div
                    className="text-white border-0 text-left d-flex justify-content-between align-items-center ms-3 "
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleDropdown("info", !dropdownOpen.info)}
                  >
                    Informations
                  </div>
                  {dropdownOpen.info && (
                    <ul className="flex-column ms-3 mt-2 list-unstyled">
                      <li>
                        <NavLink to="/Notices" className={navLinkClass} onClick={handleClick}>
                          Notices
                        </NavLink>
                      </li>
                      {/* <li>
                        <NavLink to="/jaiclublive" className={navLinkClass} onClick={handleClick}>
                          Jaiclub Connect
                        </NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/message" className={navLinkClass} onClick={handleClick}>
                          Messages
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="nav-item ms-4">
                  <NavLink to="/Contact" className={navLinkClass} onClick={handleClick}>
                    Contact
                  </NavLink>
                </li>

                <li className="nav-item ms-4 mt-3">
                  <NavLink to="/Login" className={navLinkClass} onClick={handleClick}>
                    Login
                  </NavLink>
                </li>
              </ul>
            </Offcanvas.Body>
          </Offcanvas>
        </>
      ) : (
        <>
          {/* Alternative Navbar (when showNavlinks is false) */}
          <div className="w-100 d-flex justify-content-between align-items-center fixed-top px-2">
            <div className="d-flex justify-content-between align-items-center bg-dark rounded-5">
              <BackButton />
              <span
                className="me-4 d-block"
                onClick={handleShow}
                style={{
                  cursor: "pointer",
                  color: "#E82561",
                  borderRadius: "50px",
                  padding: "5px",
                }}
              >
                <RiMenu2Fill style={{ fontSize: 25 }} />
              </span>
            </div>

            <div className="navbar-brand " onClick={() => navigate("/")}>
              <img src={logo3} loading="lazy" alt="images" style={{ width: "70%", objectFit: "contain",filter:"invert(100%)" }} />
            </div>
          </div>

          <Offcanvas show={show} onHide={handleClose} style={{ backgroundColor: "black" }} placement="start">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="text-dark">
                <div className="d-flex align-items-end">
                  <img src={logo} loading="lazy" alt="Logo" style={{ width: 80, objectFit: "cover" }} />
                  <div className="ps-3">
                    <div style={{ fontSize: "1em", fontWeight: 600, color: "#DC143C", fontFamily: '"Playwrite FR Moderne", cursive' }}>
                      Jai Club
                    </div>
                    <div style={{ fontSize: ".5em", fontWeight: 600, color: "#fff" }}>
                      THE TRUE SPIRIT OF LIFE
                    </div>
                  </div>
                </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ul className="navbar-nav flex-column">
                <li className="nav-item ms-4">
                  <NavLink to="/" className={navLinkClass} onClick={handleClick}>
                    Home
                  </NavLink>
                </li>

                {/* About Dropdown (Mobile) */}
                <li className="nav-item ms-4">
                  <div
                    className="text-white border-0 text-left d-flex justify-content-between align-items-center ms-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleDropdown("about", !dropdownOpen.about)}
                  >
                    About
                  </div>
                  {dropdownOpen.about && (
                    <ul className="flex-column ms-3 mt-2 list-unstyled">
                      <li>
                        <NavLink to="/History" className={navLinkClass} onClick={handleClick}>
                          History
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Management" className={navLinkClass} onClick={handleClick}>
                          Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Affiliation" className={navLinkClass} onClick={handleClick}>
                          Affiliations
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Event" className={navLinkClass} onClick={handleClick}>
                          Events
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/Gallery" className={navLinkClass} onClick={handleClick}>
                          Gallery
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="nav-item ms-4">
                  <NavLink to="/Facility" className={navLinkClass} onClick={handleClick}>
                    Club Facility
                  </NavLink>
                </li>

                <li className="nav-item ms-4">
                  <NavLink to="/Membership" className={navLinkClass} onClick={handleClick}>
                    Membership
                  </NavLink>
                </li>

                {/* Informations Dropdown (Mobile) */}
                <li className="nav-item ms-4">
                  <div
                    className="text-white border-0 text-left d-flex justify-content-between align-items-center ms-3"
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleDropdown("info", !dropdownOpen.info)}
                  >
                    Informations
                  </div>
                  {dropdownOpen.info && (
                    <ul className="flex-column ms-3 mt-2 list-unstyled">
                      <li>
                        <NavLink to="/Notices" className={navLinkClass} onClick={handleClick}>
                          Notices
                        </NavLink>
                      </li>
                      {/* <li>
                        <NavLink to="/jaiclublive" className={navLinkClass} onClick={handleClick}>
                          Jaiclub Connect
                        </NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/message" className={navLinkClass} onClick={handleClick}>
                          Messages
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>

                <li className="nav-item ms-4">
                  <NavLink to="/Contact" className={navLinkClass} onClick={handleClick}>
                    Contact
                  </NavLink>
                </li>

                <li className="nav-item ms-4 mt-3">
                  <NavLink to="/Login" className={navLinkClass} onClick={handleClick}>
                    Login
                  </NavLink>
                </li>
              </ul>
            </Offcanvas.Body>
          </Offcanvas>
        </>
      )}
    </div>
  );
}